import { FC } from 'react';
import { theme } from 'antd';

const { useToken } = theme;

type Props = {
  width?: number;
  height?: number;
};

const ControllerFrontIcon: FC<Props> = ({ width = 18, height = 18 }) => {
  const { token } = useToken();

  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Monitor">
        <path
          id="Vector"
          d="M14.625 2.8125H3.375C2.92745 2.8125 2.49822 2.99029 2.18176 3.30676C1.86529 3.62322 1.6875 4.05245 1.6875 4.5V12.375C1.6875 12.8226 1.86529 13.2518 2.18176 13.5682C2.49822 13.8847 2.92745 14.0625 3.375 14.0625H14.625C15.0726 14.0625 15.5018 13.8847 15.8182 13.5682C16.1347 13.2518 16.3125 12.8226 16.3125 12.375V4.5C16.3125 4.05245 16.1347 3.62322 15.8182 3.30676C15.5018 2.99029 15.0726 2.8125 14.625 2.8125ZM15.1875 12.375C15.1875 12.5242 15.1282 12.6673 15.0227 12.7727C14.9173 12.8782 14.7742 12.9375 14.625 12.9375H3.375C3.22582 12.9375 3.08274 12.8782 2.97725 12.7727C2.87176 12.6673 2.8125 12.5242 2.8125 12.375V4.5C2.8125 4.35082 2.87176 4.20774 2.97725 4.10225C3.08274 3.99676 3.22582 3.9375 3.375 3.9375H14.625C14.7742 3.9375 14.9173 3.99676 15.0227 4.10225C15.1282 4.20774 15.1875 4.35082 15.1875 4.5V12.375ZM11.8125 15.75C11.8125 15.8992 11.7532 16.0423 11.6477 16.1477C11.5423 16.2532 11.3992 16.3125 11.25 16.3125H6.75C6.60082 16.3125 6.45774 16.2532 6.35225 16.1477C6.24676 16.0423 6.1875 15.8992 6.1875 15.75C6.1875 15.6008 6.24676 15.4577 6.35225 15.3523C6.45774 15.2468 6.60082 15.1875 6.75 15.1875H11.25C11.3992 15.1875 11.5423 15.2468 11.6477 15.3523C11.7532 15.4577 11.8125 15.6008 11.8125 15.75Z"
          fill={token.colorPrimary}
        />
      </g>
    </svg>
  );
};

export default ControllerFrontIcon;
